module.exports = __webpack_public_path__ + "static/media/service_img2.6d5ad65d.png";